import { render } from "./AddDependentModal.vue?vue&type=template&id=40d633b6&scoped=true"
import script from "./AddDependentModal.vue?vue&type=script&lang=js"
export * from "./AddDependentModal.vue?vue&type=script&lang=js"

import "./AddDependentModal.vue?vue&type=style&index=0&id=40d633b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d633b6"]])

export default __exports__